module.exports = __webpack_public_path__ + "img/deskshelf00.e126487a.jpg";